import { registerDefaultsForModule, ComposedTheme } from '@glu/theming';

export const defaultTheme = ({ palette }: ComposedTheme) => ({
  // @theming labelText: Icon fill
  fill: palette.primary.normal,
  // @theming labelText: Icon size, type: pixel
  size: 16,
  actionableIcon: {
    // @theming labelText: Actionable Icon background color
    backgroundColor: palette.background,
    // @theming labelText: Actionable Icon fill
    color: palette.primary.normal,
    // @theming labelText: Disabled Actionable Icon fill
    disabledColor: palette.primary.disabled,
    // @theming labelText: Actionable Icon border color
    borderColor: palette.primary.light,
    // @theming labelText: Actionable Icon hover fill
    hoverColor: palette.text.light,
    // @theming labelText: Actionable Icon hover background color
    hoverBackgroundColor: palette.primary.normal,
  },
  actionableMenuIcon: {
    // @theming labelText: Menu background color
    menuBackgroundColor: palette.background,
    // @theming labelText: Menu border, type: string
    menuBorder: `1px solid ${palette.primary.normal}`,
    // @theming labelText: Menu button color
    menuButtonColor: '#4C4C4C',
    // @theming labelText: Menu button hover color
    menuButtonHoverColor: '#3f3f3f',
    // @theming labelText: Menu button background hover color
    menuButtonHoverBackground: palette.highlightBackground,
    // @theming labelText: Menu button padding, type: pixel
    menuButtonPadding: [8, 10],
    // @theming labelText: Menu border radius, type: pixel
    menuBorderRadius: 4,
    // @theming labelText: Menu font size, type: pixel
    menuFontSize: 14,
    // @theming labelText: Menu padding, type: pixel
    menuPadding: [5, 0],
  },
});

registerDefaultsForModule('icons', defaultTheme);

export const registerDefaults = () => {
  registerDefaultsForModule('icons', defaultTheme);
};
